const Modal = (() => {

  const modals = Array.from(document.querySelectorAll("[data-modal]")),
        focusable = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]";
  
  let focused = '';

  const trap = (e, el, focusableChildren) => {
    if (e.which == 27) {
      hide(el);
    } 
    if (e.which == 9) {
      let currentFocus = document.activeElement,
          totalOfFocusable = focusableChildren.length,
          focusedIndex = focusableChildren.indexOf(currentFocus);

      if (e.shiftKey) {
        if (focusedIndex === 0) {
          e.preventDefault();
          focusableChildren[totalOfFocusable - 1].focus();
        }
      } else {
        if (focusedIndex == totalOfFocusable - 1) {
          e.preventDefault();
          focusableChildren[0].focus();
        }
      }
    }
  }

  const hide = (el) => {
    document.body.classList.remove('has-modal');

    el.setAttribute('aria-hidden', 'true');
    el.classList.remove('modal-show');

    focused.focus();
  }

  const show = (el) => {
    let focusableChildren = Array.from(el.querySelectorAll(focusable));

    document.body.classList.add('has-modal');

    focused = document.activeElement;

    el.setAttribute('aria-hidden', 'false'); 
    el.classList.add('modal-show');

    focusableChildren[0].focus();
    
    el.onkeydown = function(e) {
      trap(e, el, focusableChildren);
    }
  }

  const createModal = (modal) => {
    const name = modal.dataset.modal,
          content = document.querySelector(`[data-modal-content="${name}"]`),
          openTrigger = document.querySelector(`[data-modal-trigger="${name}"]`),
          closeTrigger = document.querySelector(`[data-modal-close="${name}"]`);

    // wrap the modal
    const modalWrapper = document.createElement('div');

    modalWrapper.setAttribute('role', 'dialog');
    modalWrapper.setAttribute('tabindex', 0);
    
    content.parentNode.appendChild(modalWrapper);
    modalWrapper.appendChild(content);
    //
    
    modal.setAttribute('aria-hidden', 'true'); 
    modal.setAttribute('data-modal-init', 'true');

    openTrigger.onclick = (e) => {
      e.preventDefault();
      show(modal);
    }

    closeTrigger.onclick = (e) => {
      e.preventDefault();
      hide(modal);
    }
  }

  const destroyModal = (modal) => {
    if (document.body.classList.contains('has-modal')) {
      hide(modal);
    }

    modal.setAttribute('aria-hidden', 'false'); 
    modal.setAttribute('data-modal-init', 'false');

    const modalWrapper = modal.querySelector('[role="dialog"]');

    // unwrap the modal
    // https://stackoverflow.com/questions/19261197/how-can-i-remove-wrapper-parent-element-without-removing-the-child#answer-33401932
    var docFrag = document.createDocumentFragment();
    while (modalWrapper.firstChild) {
      var child = modalWrapper.removeChild(modalWrapper.firstChild);
      docFrag.appendChild(child);
    }

    modalWrapper.parentNode.replaceChild(docFrag, modalWrapper);
    //
  }

  return {
    init: () => {
      if (modals.length > 0) {
        modals.forEach(modal => {
          const breakpoint = modal.dataset.modalBreakpoint || 'default',
                modalInit = modal.dataset.modalInit || 'false';

          // Check if the modal has been initialized already
          // if not, and it should be initialized, do it
          // else if it shouldn't, remove it
          // (this is all sort of weird but the reason I wrote this is because 
          // I wanted to use the same code for my mobile nav, which should only 
          // have all of this happen on mobile)
          if (breakpoint == 'default' && modalInit == 'false') {
            createModal(modal)
          } else if (window.innerWidth < 1024 && breakpoint == 'small' && modalInit == 'false') {
            createModal(modal)
          } else if (window.innerWidth > 1024 && breakpoint == 'small' && modalInit == 'true') {
            destroyModal(modal)
          }

        });
      }
    }
  }
})();

export default Modal;


// WEBPACK FOOTER //
// ./src/js/components/modal.js